import { Module } from '../Module';

/**
* Favorite toggle for adding and removing favorites
*
* Example:
*   tb:angular-favorite-toggle(ng-model="workbook.favorite", on-add="addFavorite()", on-remove="removeFavorite()")
*
* Attributes:
*   ng-model="workbook.favorite":   Favorite bool to be toggled
*   on-add="addFn()":               Function responsible for calling Favorites service add
*   on-remove="removeFn()":         Function responsible for calling Favorites service remove
*
*
* TODO: This directive (and its associated tests) can be removed with the demise of the mixedContentEnabled feature flag.
*/

interface IFavoriteToggleScope extends ng.IScope {
  busy: boolean;
  toggle: ($event: JQueryEventObject) => void;
  selected: () => boolean;

  onAdd: () => ng.IPromise<any>;
  onRemove: () => ng.IPromise<any>;
}

Module.instance().directive('tbAngularFavoriteToggle', <any[]>[
  () => {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'favoriteToggle.html',
      scope: {
        onAdd: '&',
        onRemove: '&'
      },
      require: 'ngModel',
      link: ($scope: IFavoriteToggleScope, element: JQuery, attrs: ng.IAttributes, ngModelCtrl: ng.INgModelController) => {
        $scope.selected = () => ngModelCtrl.$viewValue;

        $scope.toggle = ($event: JQueryEventObject) => {
          $event.stopPropagation(); // Prevent list item selection

          if (ngModelCtrl.$viewValue) {
            $scope.onRemove();
          } else {
            $scope.onAdd();
          }
          ngModelCtrl.$setViewValue(!ngModelCtrl.$viewValue);
        };

      }
    };
  }
]);
